<template>
  <div class="register">
    <van-form @submit="onSubmitByVarify">
      <van-field v-model="phoneNumber" name="phoneNumber" label="手机号" placeholder="手机号" label-class="my-label" />
      <!-- <van-field v-model="password" type="password" name="验证码" label="验证码" placeholder="验证码" :rules="[{ required: true, message: '请填写验证码' }]" /> -->
      <!--      <van-field v-model="code" center clearable name="code" label="短信验证码" placeholder="请输入短信验证码" label-class="my-label">
        <template #button>
          <span style="color:#F2F2F2; margin-right:7px">|</span>
          <span class="send" @click="sendCode" v-if="buttonIsShow">{{ buttonText }}</span>
          <span class="countDwon" v-if="numIsShow">{{ countNum }}s</span>
        </template>
      </van-field> -->
      <van-field v-model="password" name="password" type="password" label="密码" placeholder="请输入密码" label-class="my-label" />
      <van-field v-model="repassword" name="repassword" type="password" label="密码确认" placeholder="请再次输入密码" label-class="my-label" />
      <div style="margin: 16px;">
        <van-button round block type="info" @click="submit">
          注册
        </van-button>
      </div>
    </van-form>
    <div class="way">
      <!-- <span @click="toggle">{{toggleText}}</span> -->
      <span @click="login">账号密码登录</span>
    </div>
  </div>
</template>

<script>
  import * as api from "@p/api";
  import Form from "@m/vant/Form";
  import Button from "@m/vant/Button";
  import NavBar from "@c/NavBar.vue";
  import {
    Toast,
    Notify
  } from "vant";
  export default {
    mixins: [Form, Button],
    data() {
      return {
        phoneNumber: "",
        code: "",
        username: "",
        password: "",
        countNum: 60, // 倒计时
        buttonText: "发送验证码", //按钮文字
        timer: null, //定时器
        buttonIsShow: true, //按钮是否显示
        numIsShow: false, //倒计时是否显示,
        repassword: ""
      };
    },
    components: {
      [Notify.Component.name]: Notify.Component
    },
    methods: {
      onSubmitByVarify(values) {
        console.log("submit", values);
      },
      onSubmitByPasswrod() {},
      sendCode() {
        this.getPhoneVerifyCode();
        this.countDown();
      },
      async getPhoneVerifyCode() {
        var params = {
          phoneNumber: this.phoneNumber
        };
        var res = await api.requestApiGet("getPhoneVerifyCode", params);
        console.log(res);
      },
      toggle() {
        if (this.loginWay) {
          this.loginWay = false;
          this.toggleText = "手机验证码登录";
        } else {
          this.loginWay = true;
          this.toggleText = "账号密码登录";
        }
      },
      countDown() {
        if (this.phoneNumber === "" || !this.phoneNumber) {
          return false;
        } else {
          // this.getPhoneVerifyCode();
          this.buttonIsShow = false;
          this.numIsShow = true;

          this.timer = setInterval(() => {
            this.countNum--;
            if (this.countNum === 0) {
              clearInterval(this.timer);
              this.countNum = 60;
              this.buttonIsShow = true;
              this.numIsShow = false;
              this.buttonText = "重新发送";
            }
          }, 1000);
        }
      },
      async submit() {
        var isMobilePhone = /^[1]([3-9])[0-9]{9}$/;
        var isFixMob = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,8}$/;
        if (this.password !== this.repassword) {
          Notify({
            type: 'danger',
            message: '两次输入密码不一致'
          });
          return;
        } else if (this.password.length < 6) {
          Notify({
            type: 'danger',
            message: '密码过短'
          });
          return;
        } else if (!isMobilePhone.test(this.phoneNumber) && !isFixMob.test(this.phoneNumber)) {
          Notify({
            type: 'danger',
            message: '请输入正确的手机号'
          });
          return;
        }
        var params = {
          // code: this.code,
          password: this.password,
          phoneNumber: this.phoneNumber
        };
        params.openId = localStorage.getItem("openId")
        var res = await api.requestApiByPost("register", params);
        Notify({
          type: 'success',
          message: '注册成功'
        });
        this.login()
      },
      login() {
        this.$router.push("/login");
      }
    }
  };
</script>

<style lang="less" scoped>
  .van-button--primary {
    background: none;
    border: none;
    color: @primary;
  }

  .way {
    display: flex;
    padding: 0 16px;
    justify-content: space-between;

    span {
      color: @gray-6;
      font-size: @font-size-md;
    }
  }
</style>
